import { Pipe, PipeTransform } from '@angular/core';

import { NaturezaVenda } from '../../natureza-venda';

@Pipe({
    name: 'naturezaVendaSituacaoFilter',
    pure: false
})
export class NaturezaVendaSituacaoFilterPipe implements PipeTransform {
    /** Filtra as naturezas de vendas pela situação informada */
    transform(entities: NaturezaVenda[], situacao: number = null): NaturezaVenda[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as naturezas de vendas quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacao === situacao);
    }
}
